import { PageLayout } from "../components/PageLayout";
import { Coder } from "../features/coder/Coder";

export const CoderPage: React.FC = () => {
  return <PageLayout>
    <Coder />
  </PageLayout>;
};